import {ValueOrderEntitlementsApiInterface} from "../api/interface/value-order-entitlements";
import {selectCredentials} from "./authSlice";
import type {RevaThunkAction} from "./revaHooks";
import {
    isValueOrderEntitlementsStale,
    selectValueOrderEntitlementsState,
    setValueOrderEntitlementsFailed,
    setValueOrderEntitlementsLoaded,
    setValueOrderEntitlementsLoading,
} from "./valueOrderEntitlementsSlice";

/**
 * Lädt die Freischaltungen beim ValueAG-Auftraggeber der Lizenz des angemeldeten Benutzers (reva-rest cacht
 * zusätzlich). No-op, solange geladen wird oder die letzte Antwort noch gilt (siehe
 * {@link isValueOrderEntitlementsStale}). Fehler bleiben still: das Beauftragen wird dann wie ohne Prüfung angeboten.
 * @param force true lädt auch dann, wenn die letzte Antwort noch gilt (nicht aber während einer laufenden Abfrage)
 */
export const loadValueOrderEntitlementsThunk =
    (force = false): RevaThunkAction<Promise<void>> =>
    async (dispatch, getState, {serviceApi}) => {
        const current = selectValueOrderEntitlementsState(getState());
        if (current.loading || (!force && !isValueOrderEntitlementsStale(current, Date.now()))) {
            return;
        }
        const credentials = selectCredentials(getState());
        if (!credentials) {
            return;
        }
        dispatch(setValueOrderEntitlementsLoading());
        const requestSeq = selectValueOrderEntitlementsState(getState()).requestSeq;
        try {
            const data = await new ValueOrderEntitlementsApiInterface().execute(serviceApi, credentials);
            dispatch(setValueOrderEntitlementsLoaded({requestSeq, data, loadedAt: Date.now()}));
        } catch (err) {
            console.warn("Freischaltungen beim ValueAG-Auftraggeber nicht abrufbar", err);
            dispatch(setValueOrderEntitlementsFailed({requestSeq, loadedAt: Date.now()}));
        }
    };
